import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_AMP_CUSTOMER_DATA,
  API_COMPLETE_GET_AMP_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AMP_CUSTOMER_DATA,
  API_INITIATE_POST_AMP_OPTIMIZE_PLAN_DATA,
  API_COMPLETE_POST_AMP_OPTIMIZE_PLAN_DATA,
  API_INITIATE_SUBMIT_AMP_CUSTOMER_DATA,
} from '../../app-constants';
import View from './amp-homepage.presenter';
import { submitAMPCustomerData, submitAMPOptimizePlanData } from './amp-homepage.actions';
// Reducer
export const ampHomePageReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  customerAccountName: '',
  customerAccountNumber: '',
  customerAbn: '',
  getData: '',
  referenceNumber: '',
  alreadySubmitted: false,
  optimizeInProgress: false,
  submissionInProgress: false,
  loadedOptimizeData: false,
  optimizePlanData: '',
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_AMP_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, formSubmitted: false };
    case API_INITIATE_SUBMIT_AMP_CUSTOMER_DATA:
      return { ...state, formSubmitted: false, submissionInProgress: true };
    case API_COMPLETE_SUBMIT_AMP_CUSTOMER_DATA:
      return { ...state, loading: false, formSubmitted: true, submissionInProgress: false };
    case API_COMPLETE_GET_AMP_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        customerAccountName: action.data.accountName,
        customerAccountNumber: action.data.accountNumber,
        customerAbn: action.data.abn,
        getData: action.data,
        alreadySubmitted: action.data.alreadySubmitted,
      };
    }
    case API_INITIATE_POST_AMP_OPTIMIZE_PLAN_DATA:
      return { ...state, optimizeInProgress: true };
    case API_COMPLETE_POST_AMP_OPTIMIZE_PLAN_DATA:
      return { ...state, optimizeInProgress: false, optimizePlanData: action.data, loadedOptimizeData: true };
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumber: state.ampHomePageReducer.customerAccountNumber,
  customerAccountName: state.ampHomePageReducer.customerAccountName,
  customerAbn: state.ampHomePageReducer.customerAbn,
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.ampHomePageReducer.dataLoaded,
  getData: state.ampHomePageReducer.getData,
  formSubmitted: state.ampHomePageReducer.formSubmitted,
  referenceNumber: state.ampHomePageReducer.referenceNumber,
  alreadySubmitted: state.ampHomePageReducer.alreadySubmitted,
  optimizePlanData: state.ampHomePageReducer.optimizePlanData,
  optimizeInProgress: state.ampHomePageReducer.optimizeInProgress,
  loadedOptimizeData: state.ampHomePageReducer.loadedOptimizeData,
  submissionInProgress: state.ampHomePageReducer.submissionInProgress,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitAMPCustomerData,
    submitAMPOptimizePlanData,
  }, dispatch),
});

const AMPHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default AMPHomePage;
